import './css/main.css';
import './css/aos.css';

function App() {
  return (
    // <!-- Begin page -->
    <div className="wrapper">
    {/* <!-- Start Page Content -->
        <!-- Back to top button --> */}
        <button id="backtop" aria-label="Back to top">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-up" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
            </svg>
        </button>
        {/* 
        <!-- Topbar start -->  */}
        <nav className="navbar bg-blue primary-navbar" aria-label="Main navigation">
            <div className="container-fluid py-4 align-items-center">
              <div className="nav-brand"><a href="#home" aria-label="Pravid Technologies home"><img src="/img/logo.png" alt="Pravid Technologies LLC logo" title="Pravid Technologies LLC" /></a></div>
                <div className="justify-content-end menu-scroll" >
                    <ul className="navbar-nav my-3 my-md-0  d-flex flex-row gap-3 gap-md-4 gap-lg-5 ">
                        <li className="nav-item">
                            <a className="nav-link" href="#services" >Services</a>
                        </li>
                        <li className="nav-item">
                        <a className="nav-link"  href="#about">About</a>
                        </li>
                        <li className="nav-item">
                        <a className="nav-link" href="#solutions">Solutions</a>
                        </li>
                        <li className="nav-item">
                        <a className="nav-link" href="#benefits">Benefits</a>
                        </li>
                        <li className="nav-item">
                        <a className="nav-link" href="#contact">Contact</a>
                        </li>
                    </ul>  
                </div>
            </div>
        </nav> 
        {/* <!-- Topbar end --> 
        <!-- Hero start -->  */}
        <section className="hero bg-blue  py-5">
           <div className="container-fluid py-4"> 
                <div className="row align-items-center">
                    <div className="col-md-12 col-lg-6">
                        <p className="punchline">Cloud Solutions</p>
                        <h1>
                            Grow your <span>business</span> with cloud platform
                        </h1>
                        <div className="row py-5 summary">
                            <div className="col-6 col-md-4 col-lg-4 summary-list">
                                <h2>+19%</h2>
                                <p>To the performance of  cloud apps</p>
                            </div>
                            <div className="col-6 col-md-4 col-lg-4 summary-list">
                                <h2>-37%</h2>
                                <p>To cloud consumption cost</p>
                            </div>
                            <div className="col-6 col-md-4 col-lg-4  summary-list">
                                <h2>+75%</h2>
                                <p>To the productivity of IT Infrastructure Teams</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 col-lg-6 text-md-center text-lg-end">
                       <img src="/img/img-hero.png" alt="Cloud computing illustration" className="img-fluid" data-aos="fade-up" />
                    </div>
                </div>
            </div>    
        </section>
        {/* <!-- Hero end --> 
        <!-- Service start -->  */}
        <section id="services" className="  py-5 services" >
            <div className="container-fluid py-4">
                <div className="pt-4">
                    <div className="row   align-items-center">
                        <div className="col-md-8 col-lg-5">
                            <div className="primary-heading">
                                <p className="punchline">Offered Services</p>
                                <h2 className="heading-1">Cloud solution take
                                    <span>business</span> new heights</h2>
                            </div> 
                        </div>
                        <div className="col-md-4 col-lg-7 text-end">
                            <iconify-icon className="icon-highlight" icon="ph:dots-nine-light"></iconify-icon>
                        </div>
                    </div>
                    <div className="row row-cols-md-2 row-cols-lg-3 mt-5">
                        <div className="col mb-4" data-aos="fade-left" data-aos-delay="100">
                            <div className="card active">
                                <div className="card-body">
                                  <iconify-icon className="icon-service" icon="material-symbols:business-center-outline-rounded"></iconify-icon>
                                  <h3 className="card-title">Cloud Strategy</h3>
                                  <p className="card-text">Are you getting value from the cloud? We help you create a comprehensive cloud strategy, from planning and readiness assessments to defining governance
                                  </p>
                                </div>
                            </div>
                        </div>
                        <div className="col mb-4" data-aos="fade-left" data-aos-delay="200">
                            <div className="card">
                                <div className="card-body">
                                  <iconify-icon className="icon-service bg-pink text-white" icon="ic:baseline-settings-suggest"></iconify-icon>
                                  <h3 className="card-title">Cloud Transformation</h3>
                                  <p className="card-text">Modernize your legacy applications and grow your business through cloud transformation.
                                  </p>
                                </div>
                            </div>
                        </div>
                        <div className="col mb-4" data-aos="fade-left" data-aos-delay="300"> 
                            <div className="card">
                                <div className="card-body">
                                  <iconify-icon className="icon-service bg-yellow text-white" icon="carbon:ibm-cloud-security-compliance-center"></iconify-icon>
                                  <h3 className="card-title">Cloud Security</h3>
                                  <p className="card-text">Protecting your most valuable data — the confidentiality, integrity, and privacy of individual data subjects — is critical.
                                  </p>
                                </div>
                            </div>
                        </div>
                        <div className="col mb-4 mb-md-0"  data-aos="fade-left" data-aos-delay="400"> 
                            <div className="card">
                                <div className="card-body">
                                  <iconify-icon className="icon-service bg-green text-white" icon="material-symbols:cloud-done-outline"></iconify-icon>
                                  <h3 className="card-title">Cloud Managed Services</h3>
                                  <p className="card-text">Focus on your key business activities and core competencies and let Proactivity manage your cloud operations and processes.
                                  </p>
                                </div>
                            </div>
                        </div>
                        <div className="col mb-4 mb-md-0" data-aos="fade-left" data-aos-delay="500"> 
                            <div className="card">
                                <div className="card-body">
                                  <iconify-icon className="icon-service bg-purple text-white" icon="carbon:idea"></iconify-icon>
                                  <h3 className="card-title">Cloud Innovation</h3>
                                  <p className="card-text">Underpinned by the power of the cloud, emerging technologies drive innovation.
                                  </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               
            </div>
        </section>
        {/* <!-- Service end -->
        <!-- About start -->  */}
        <section className="py-0 py-lg-5" id="about">
            <div className="container-fluid py-0 py-lg-4">
                <div className="row  align-items-center about rounded-3">
                    <div className="col-md-12  col-lg-5">
                        <div className="primary-heading">
                            <p className="punchline">About Us</p>
                            <h2 className="heading-2">Startup company having excellent team  </h2>
                            <p className="para-display">The growing complexity of data regulations, varied data frameworks, and data governance issues are a few of the major challenges in achieving data-driven success today.
                            </p>
                            <a href="#contact" className="btn btn-white btn-lg   col-md-6 mt-3 mb-4  mb-lg-0">Let’s Connect</a>
                        </div> 
                    </div>
                    <div className="col-md-12 col-lg-7 pt-md-5 pt-lg-0 text-md-end"  data-aos="fade-up">
                       <img src="/img/img-about.png" alt="Pravid Technologies team" className="img-mob" />
                    </div>
                </div> 
            </div>
        </section>
        {/* <!-- About end -->
        <!-- Solutions start -->  */}
        <section  id="solutions" className="py-5">
            <div className="container-fluid py-4 ">
                <div className="row">
                    <div className="col-md-10 col-lg-5">
                        <div className="primary-heading">
                            <p className="punchline">Cloud solutions</p>
                            <h2 className="heading-1">Cloud solutions works
                                for <span>many industries</span></h2>
                            <p>We design tailored cloud architectures that improve scalability, resilience, and cost-efficiency across industries.</p>    
                        </div> 
                    </div>
                    <div className="col-md-12 col-lg-7">
                        <div className="row pt-5 pt-lg-0">
                            <div className="col-12 col-md-12 col-lg-9 mx-auto">
                                <div className="row row-cols-1 row-cols-md-2 gy-3 gy-md-4" data-aos="zoom-in">
                                    <div className="col" >
                                        <div className="solutions bg-pink text-white">
                                            <iconify-icon className="icon-solutions" icon="carbon:game-console" aria-hidden="true"></iconify-icon>
                                           <div className="solutions-content">
                                                <h5 className="solutions-heading">Gaming</h5>
                                                <p className="solutions-desc">Deliver low-latency, scalable backend services, real-time matchmaking, and cost-optimized infrastructure for game studios.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col" >
                                        <div className="solutions bg-yellow text-black">
                                            <iconify-icon className="icon-solutions" icon="ri:movie-2-line" aria-hidden="true"></iconify-icon>
                                           <div className="solutions-content">
                                                <h5 className="solutions-heading">Entertainment</h5>
                                                <p className="solutions-desc">Enable streaming-ready platforms with autoscaling, CDN integration, and content delivery optimization for media providers.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col"  >
                                        <div className="solutions bg-primary text-white">
                                            <iconify-icon className="icon-solutions" icon="fluent:building-retail-more-24-regular" aria-hidden="true"></iconify-icon>
                                           <div className="solutions-content">
                                                <h5 className="solutions-heading">Retails</h5>
                                                <p className="solutions-desc">Power omnichannel retail with secure, scalable e‑commerce platforms, inventory synchronization, and analytics-driven personalization.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col"  >
                                        <div className="solutions bg-green text-black">
                                            <iconify-icon className="icon-solutions" icon="iconoir:healthcare" aria-hidden="true"></iconify-icon>
                                           <div className="solutions-content">
                                                <h5 className="solutions-heading">Healthcare</h5>
                                                <p className="solutions-desc">Provide secure, compliant cloud solutions for patient data, telehealth, and analytics to improve outcomes and maintain privacy.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </section>
        {/* <!-- Solutions end -->
        <!-- Benefits and Technology start -->  */}
        <section id="benefits" className="bg-blue-light py-5 ">
            <div className="container-fluid py-0 py-md-4 my-5">
                <div className="row">
                    <div className="col-lg-7 mb-5 py-3">
                        <div className="primary-heading">
                            <p className="punchline">Business run smoothly on all platform</p>
                            <h2 className="heading-1">Taking your business on cloud 
                                platform get <span>many benefits</span>
                            </h2>
                        </div>
                    </div>
                    <div className="col-lg-8  ">
                        <div className="row row-cols-1 row-cols-md-2  g-5">
                            <div className="col-md-5">
                                <div className="primary-heading">
                                    <h3 className="heading-3">Reduce Migration Cost</h3>
                                    <p className="para-faded">We minimize migration effort through automated tooling, phased lift-and-shift approaches, and careful refactor planning to reduce upfront cost.</p>
                                </div>
                            </div>
                            <div className="col-md-5 offset-md-2 ">
                                <div className="primary-heading">
                                    <h3 className="heading-3">Optimized Monthly Cloud Cost</h3>
                                    <p className="para-faded">Continuous cost optimization, rightsizing, and reserved or committed-use strategies lower your monthly cloud spend while preserving performance.</p>
                                </div>
                            </div>
                            <div className="col-md-5 ">
                                <div className="primary-heading">
                                    <h3 className="heading-3">High Development Speed</h3>
                                    <p className="para-faded">DevOps automation, CI/CD pipelines, and containerized environments accelerate development cycles and reduce time-to-market.</p>
                                </div>
                            </div>
                            <div className="col-md-5 offset-md-2 ">
                                <div className="primary-heading">
                                    <h3 className="heading-3">Enhance Security for all platform</h3>
                                    <p className="para-faded">Comprehensive security posture with IAM, encryption, continuous monitoring, and compliance controls across all environments.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-3 offset-lg-1 pt-md-5 pt-lg-0" >
                        <div className="primary-heading">
                            <h4 className="heading-4"> Cloud we work with</h4>
                        </div>
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-1 tech-support" data-aos="fade-up">
                            <div className="cols">
                                <a href="https://aws.amazon.com" rel="noopener noreferrer" target="_blank" aria-label="Amazon Web Services">
                                    <img src="/img/img-aws.png" alt="Amazon Web Services" />
                                </a>
                            </div>
                            <div className="cols">
                                <a href="https://cloud.google.com" rel="noopener noreferrer" target="_blank" aria-label="Google Cloud">
                                    <img src="/img/img-gcloud.png" alt="Google Cloud" />
                                </a>
                            </div>
                            <div className="cols">
                                <a href="https://www.digitalocean.com" rel="noopener noreferrer" target="_blank" aria-label="DigitalOcean">
                                    <img src="/img/img-docean.png" alt="DigitalOcean" />
                                </a>
                            </div>
                            <div className="cols">
                                <a href="https://azure.microsoft.com" rel="noopener noreferrer" target="_blank" aria-label="Microsoft Azure">
                                    <img src="/img/img-mazure.png" alt="Microsoft Azure" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <!-- Benefits and Technology end --> 
        <!-- Contact start --> */}
        <section className="contact py-5" id="contact" >
            <div className="container-fluid py-4">
                <div className="row  ">
                    <div className="col-md-12 col-lg-6 mx-auto text-center ">
                        <div className="primary-heading">
                            <p className="punchline">lets connect  </p>
                            <h2 className="heading-2">Start taking advantage of 
                                <span>cloud technology</span></h2>
                            <p className="para-display pb-0 mb-0">Find the best expert for your needs with us  
                                <br />let's connect on  <a href="tel:+14252362445"> (+1) 425 236-2445</a></p>
                        </div>   
                    </div>
                </div>
            </div>
        </section>
        {/* <!-- Contact start --> */}
        {/* <!-- Footer start --> */}
        <footer className="footer">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 pb-3 pb-md-0 text-center">
                        <ul className="p-0 list-unstyled d-flex flex-row gap-3 justify-content-center">
                            <li className="mb-3">
                                <a href="#services">Services</a>
                            </li>
                            <li className="mb-3">
                                <a href="#about">About</a>
                            </li>
                            <li className="mb-3">
                                <a href="#solutions">Solutions</a>
                            </li>
                            <li className="mb-3">
                                <a href="#benefits">Benefits</a>
                            </li>
                            <li className="mb-3">
                                <a href="#contact">Contact</a>
                            </li>
                        </ul>  
                        <p className="copyright m-0">&copy; 2023 Pravid Technologies LLC | All Rights Reserved</p>      
                    </div> 
                </div>
            </div>
        </footer>    
        {/* <!-- Footer end --> */}
    </div>  
  );
}

export default App;
